/**
 * Encodes a string to a Base64 URL-safe string (RFC 4648 §5).
 * - Replaces '+' with '-', '/' with '_', and removes '=' padding.
 * @param input The string to encode.
 */
export function base64UrlEncode(input: string): string {
    // Encode the string to UTF-8 bytes
    const utf8Bytes = new TextEncoder().encode(input);
    
    // Convert bytes to a regular Base64 string
    const base64 = btoa(String.fromCharCode(...utf8Bytes));
    
    // Convert Base64 to Base64URL
    const base64Url = base64
        .replace(/\+/g, "-") // Replace '+' with '-'
        .replace(/\//g, "_") // Replace '/' with '_'
        .replace(/=+$/, ""); // Remove trailing '='
    
    return base64Url;
}
